import React from 'react';
import Layout from './Layout';

export function Badge(props: { number: number | string, withBorder?: boolean }) {
  return <Layout {...props} />;
}
